import { render, staticRenderFns } from "./step-fees-selectionV3.vue?vue&type=template&id=99ffb372&"
import script from "./step-fees-selectionV3.vue?vue&type=script&lang=js&"
export * from "./step-fees-selectionV3.vue?vue&type=script&lang=js&"
import style0 from "./step-fees-selectionV3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports